module.exports = {

    TaskNextStep: "TaskNextStep"        //引导下一步任务
    , CloseTaskEffect: "CloseTaskEffect"        //引导任务界面被关闭
    , OpenTaskEffect: "OpenTaskEffect"        //打开界面判断是否引导界面

    ,NewPlayerGuideStart:"NewPlayerGuideStart"  //新手引导开始，关闭特效
    ,NewPlayerGuideClose:"NewPlayerGuideClose"  //新手引导结束，开启特效

    ,CloseButtonListPanelEffect:"CloseButtonListPanelEffect" //关闭出击界面的手指特效
};
